export default "__VITE_ASSET__DBeCVmvS__"